// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__gWDiC","link":"SearchBar_link__HXK9v","searchIconWrapper":"SearchBar_searchIconWrapper__htPHO"};